import React, { useState, useEffect } from 'react';

import { formatToFixedMoneyWithLocale } from 'Helpers/formatService';

import ArrowTopRightOnSquareIcon from 'Assets/icons/arrow-top-right-on-square.svg';

export default function ProcurementContractManagement(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [dataset, setDataset] = useState({});

    useEffect(() => {
        fetchDataset();
    }, []);

    const fetchDataset = () => {
        setIsLoading(true);
        axios
            .get(props.fetchContractStatsUrl)
            .then(({ data }) => {
                setDataset(data);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <div className="tw-rounded-lg tw-bg-white tw-shadow-primary tw-px-6 tw-py-6.5">
            <div className="tw-mb-3">
                <h4 className="tw-text-blue tw-text-2xl tw-font-semibold tw-mb-6">{$t('Contract Management')}</h4>
                <div className="tw-flex tw-gap-1 max-lg:tw-flex-col">
                    <div className="tw-w-6/12 max-lg:tw-w-full">
                        <div className="inbud-table_wrapper tw-border-0">
                            <table className="inbud-table">
                                <tbody>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Suppliers')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">{dataset?.stats?.suppliers_count}</td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Contracts')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">{dataset?.stats?.contracts_count}</td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Average Contract Value')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {formatToFixedMoneyWithLocale(dataset?.stats?.contracts_average_value)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Total Value of Contracts')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {formatToFixedMoneyWithLocale(dataset?.stats?.contracts_total_value)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Total Milestones')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">{dataset?.stats?.milestones_count}</td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Milestones Completed')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.milestones_completed_count}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">
                                            {dataset?.stats?.milestones_overdue_count > 0 ? (
                                                <a href={props.supplierContractsTermOverduesIndexUrl}>
                                                    {$t('Milestones Overdue')}
                                                    <ArrowTopRightOnSquareIcon className="tw-w-2.5 tw-h-2.5 tw-ml-1" />
                                                </a>
                                            ) : (
                                                $t('Milestones Overdue')
                                            )}
                                        </td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.milestones_overdue_count}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="tw-w-6/12 max-lg:tw-w-full">
                        <div className="inbud-table_wrapper tw-border-0">
                            <table className="inbud-table tw-bg-white tw-border-0">
                                <thead>
                                    <tr className="tw-capitalize">
                                        <th className="!tw-bg-white !tw-border-0"></th>
                                        <th className="!tw-bg-white !tw-border-0">{$t('Payment milestones')}</th>
                                        <th className="!tw-bg-white !tw-border-0">{$t('Other milestones')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Open Milestones')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.payment_milestone_open_count}
                                        </td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.other_milestone_open_count}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Open Milestones - Overdue')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.payment_milestone_open_overdue_count}
                                        </td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.other_milestone_open_overdue_count}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Completed Milestones')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.payment_milestone_completed_count}
                                        </td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.other_milestone_completed_count}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Completed Milestones - On time')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.payment_milestone_completed_ontime_count}
                                        </td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.other_milestone_completed_ontime_count}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Completed Milestones - After due date')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.payment_milestone_completed_late_count}
                                        </td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.other_milestone_completed_late_count}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="!tw-bg-white !tw-border-0">{$t('Average # days delayed')}</td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.payment_milestone_average_days_delayed}
                                        </td>
                                        <td className="tw-font-semibold !tw-bg-white !tw-border-0 inbud-numeric-cell">
                                            {dataset?.stats?.other_milestone_average_days_delayed}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
